<template>
    <el-table
        :data="data"
        ref="table"
        empty-text="無資料"
        size="small"
        style="width: 100%"
        class="accounting-annual-tax-payment-sub-table"
        show-summary
        :summary-method="getTableSummaries"
        :default-sort="{ prop: 'paY_DAT', order: 'ascending' }"
    >
        <el-table-column prop="payoo" label="來源請款單號" width="110">
            <template slot-scope="scope">
                <el-button type="text" style="font-weight: bold; padding: 0; font-size: 9pt" @click="$emit('open', scope.row.sno)">
                    {{ scope.row.payoo }}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="paymentName" label="摘要" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="serviceType" label="所得類別" width="80">
            <template slot-scope="scope">
                {{ getIncomeTypeTxt(scope.row.serviceType) }}
            </template>
        </el-table-column>
        <el-table-column prop="serviceSubType" label="業別代號" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                {{ getServiceTypeTxt(scope.row.serviceSubType) }}
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="金額" align="right" width="130">
            <template slot-scope="scope">
                <div>
                    <Money :v="scope.row.amount" zero="-" />
                </div>
                <template v-if="scope.row.cny !== 'TWD'">
                    <div>
                        <Money :v="scope.row.originAmount" zero="-" />
                        <span style="margin-left: 5px">{{ scope.row.cny }}</span>
                    </div>
                    <div>匯率：{{ scope.row.paY_CNYRAT }}</div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="taX_AMT" label="稅款" align="right" width="100">
            <template slot-scope="scope">
                <div>
                    <Money :v="scope.row.taX_AMT" zero="-" />
                </div>
                <template v-if="scope.row.cny !== 'TWD'">
                    <div>
                        <Money :v="scope.row.originTAX_AMT" zero="-" />
                        <span style="margin-left: 5px">{{ scope.row.cny }}</span>
                    </div>
                    <div>匯率：{{ scope.row.paY_CNYRAT }}</div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="incomeNet" label="所得淨額" align="right" width="120">
            <template slot-scope="scope">
                <div>
                    <Money :v="scope.row.incomeNet" zero="-" />
                </div>
                <template v-if="scope.row.cny !== 'TWD'">
                    <div>
                        <Money :v="scope.row.originIncomeNet" zero="-" />
                        <span style="margin-left: 5px">{{ scope.row.cny }}</span>
                    </div>
                    <div>匯率：{{ scope.row.paY_CNYRAT }}</div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="geN2_AMT" label="代扣二代健保" align="right" width="120">
            <template slot-scope="scope">
                <div>
                    <Money :v="scope.row.geN2_AMT" zero="-" />
                </div>
                <template v-if="scope.row.cny !== 'TWD'">
                    <div>
                        <Money :v="scope.row.originGEN2_AMT" zero="-" />
                        <span style="margin-left: 5px">{{ scope.row.cny }}</span>
                    </div>
                    <div>匯率：{{ scope.row.paY_CNYRAT }}</div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="paY_DAT" label="給付日期" align="center" width="120">
            <template slot-scope="scope">
                <div style="font-weight: bold">
                    {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _, { template } from 'lodash';
import { serviceTypeList, serviceType9AList, serviceType9BList } from '@/assets/commonData/options';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        getIncomeTypeTxt(serviceType) {
            const s = serviceTypeList.find((x) => x.value === serviceType);
            return s ? s.type : '';
        },
        getServiceTypeTxt(serviceSubType) {
            const allServiceList = serviceType9AList.concat(serviceType9BList);
            const s = allServiceList.find((x) => x.key === serviceSubType);
            return s ? `${s.key}：${s.label}` : '無';
        },
        getTableSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            const totalAmount = _.sumBy(data, 'amount');
            const totalTaxAmount = _.sumBy(data, 'taX_AMT');
            const totalIncomeNetAmount = _.sumBy(data, 'incomeNet');
            const totalGen2Amount = _.sumBy(data, 'geN2_AMT');

            columns.forEach((column, index) => {
                if (column.property === 'paymentName') {
                    sums[index] = '總計';
                    return;
                }

                if (column.property === 'amount') {
                    sums[index] = totalAmount !== 0 ? Number(totalAmount).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'taX_AMT') {
                    sums[index] = totalTaxAmount !== 0 ? Number(totalTaxAmount).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'incomeNet') {
                    sums[index] = totalIncomeNetAmount !== 0 ? Number(totalIncomeNetAmount).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'geN2_AMT') {
                    sums[index] = totalGen2Amount !== 0 ? Number(totalGen2Amount).toLocaleString('en') : '-';
                }
            });

            return sums;
        },
    },
};
</script>

<style lang="scss">
.accounting-annual-tax-payment-sub-table {
    &::before {
        height: 0 !important;
    }
    .el-table__header-wrapper .el-table-column--selection .cell {
        display: none !important;
    }
    .el-table__footer-wrapper td {
        border-bottom: 0 !important;
    }
}
</style>
